// Mono kicker with a leading rule — the section label used across the site.
const Eyebrow = ({ children, className = "" }) => (
  <div className={`eyebrow ${className}`.trim()}>
    <span className="eyebrow__label">{children}</span>
  </div>
);

export default Eyebrow;
